import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Logo from '../../Assets/images/logo.png';
import Banner from '../../Assets/images/banner.jpg';
import { useNavigate, useSearchParams   } from 'react-router-dom';
import { resetPassword, resetPasswordVerify } from '../../Services/Authentication.Serivice'; 
import Toaster from '../../Components/Toaster';

function ResetPassword(){
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
    const [formSubmit, setFormSubmit] = useState(false);
    const dirPath = process.env.REACT_APP_SUB_DIR;

    const handleLogin = () => {
        navigate("/login");
    };

    useEffect(() => {
        const handleResetPassword = async () => {
            if(token && !formSubmit) {           
                try {
                    const response = await resetPasswordVerify(token);

                    if (response.status === false) {
                        setToastMessage(response.message);
                        setToastVariant('success');
                        setShowToast(true);
                        setTimeout(() => { handleLogin(); }, 3000);
                      } 

                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 403) {
                            setToastMessage(error.response?.data?.message || 'Unauthorized access.');
                            setToastVariant('error');
                            setShowToast(true);
                            setTimeout(() => { handleLogin(); }, 3000); 
                        }
                    } else {
                        setToastMessage(error.response?.data?.error || 'An error occurred. Please try again later.');
                        setToastVariant('error');
                        setShowToast(true);
                    }
                }
            }
        };

        handleResetPassword(); // Call the async function
    }, [token, navigate, handleLogin]);

    // Form validation schema
    const validationSchema = Yup.object({
        password: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .max(20, 'Password must not be greater than 20 characters')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[0-9]/, 'Password must contain at least one digit')
            .matches(/[\W_]/, 'Password must contain at least one special character') 
            .required('Password is required'),
        confirmpassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required'),
    });

    // Handle form submission
    const handleSubmit = async (values, { setSubmitting, setErrors, resetForm  }) => {
        setFormSubmit(true);
        try {
            const response = await resetPassword(token, values.password, values.confirmpassword);

            if (response.status) {
              setToastMessage(response.message);
              setToastVariant('success');
              setShowToast(true);
              setTimeout(() => { handleLogin(); }, 3000);     
            } else {
              setToastMessage('Failed to reset password. Please contact administrator.');
              setToastVariant('error');
              setShowToast(true);
            }
        } catch (error) {            
            if (error.response) {
                if (error.response.status === 401) {
                    setToastMessage(error.response?.data?.message || 'Unauthorized access.');
                    setToastVariant('error');
                    setShowToast(true);
                }
            } else {
                setToastMessage(error.response?.data?.error || 'An error occurred. Please try again later.');
                setToastVariant('error');
                setShowToast(true);
            }
        }

        setSubmitting(false);
        resetForm()
    };

return (
    <>
     <main className="d-flex align-items-center bg-white"  style={{background:` url(${Banner}) left center no-repeat` , backgroundSize: 'cover'}}>
        <section className="el-login-sec w-100">
            <div className=" ml-auto d-block   ">
                <div className="el-login-background d-block box-shadow-none  ">
                    <div className="el-login-card  ml-lg-auto d-block  ">
                        <div className="el-login-logo">
                            <img src={Logo} className="img-fluid  logindonar-x-logo " alt="janssen logo"/>
                        </div>
                        <h2>Reset Password</h2>

                        <Formik
                        initialValues={{ password: '', confirmpassword: '' }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        >
                        {({ isSubmitting }) => (
                            <Form className="el-login-form">
                            <div className="el-form-group mb-3">
                                <label htmlFor="password" className="form-label">Password<span className="text-red">*</span></label>
                                <Field
                                type="password"
                                name="password"
                                placeholder="Password"
                                className="form-control"
                                id="password"
                                maxLength = {20}
                                />
                                <ErrorMessage name="password" component="div" className="text-danger" />
                            </div>

                            <div className="el-form-group mb-3">
                                <label htmlFor="confirmpassword" className="form-label">Confirm Password<span className="text-red">*</span></label>
                                <Field
                                type="password"
                                name="confirmpassword"
                                placeholder="Confirm Password"
                                className="form-control"
                                id="confirmpassword"
                                maxLength = {20}
                                />
                                <ErrorMessage name="confirmpassword" component="div" className="text-danger" />
                            </div>

                            <div className="el-form-group mb-3">
                                Note : The password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.
                            </div>

                            <div className="el-form-btn-submit">
                                <button type="submit" className="el-btn-primary" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>

                            <div className="el-form-link text-center">
                                <a onClick={() => navigate(handleLogin())} className="elfotget-password">Back to Login</a>
                            </div>
                            </Form>
                        )}
                        </Formik>
                        
                    </div>
                </div>
            </div>
        </section>
    </main>

    {/* Reusable Toaster */}
    <Toaster 
        show={showToast} 
        message={toastMessage} 
        variant={toastVariant} 
        onClose={() => setShowToast(false)} 
      />

    </>
);

}
export default ResetPassword;